// native slider for pp2-reviews-native (replaces instant-core Swiper)
// CSS-driven scroll (overflow-x:auto) + controlled snap on release. No remote script,
// no init-once bug: layout is read live, so resize never breaks it.
(function(){
  var SPEED=300, LONG_RATIO=0.5, SHORT_MS=300, SHORT_PX=20, TAP_PX=8;
  function easeOutCubic(t){return 1-Math.pow(1-t,3);}
  function setup(root){
    if(root.dataset.hbpp2revInit) return; root.dataset.hbpp2revInit='1';
    var slider=root.querySelector('.hbpp2rev-slider');
    var slides=[].slice.call(root.querySelectorAll('.hbpp2rev-slider-slide'));
    var prev=root.querySelector('.hbpp2rev-slider-button-prev');
    var next=root.querySelector('.hbpp2rev-slider-button-next');
    if(!slider||!slides.length) return;
    // replica del tagging Intelligems (el script de la tienda lo hace para .instant-slider-slide;
    // el native usa .hbpp2rev-slider-slide -> lo taggeamos aqui). El CSS .has-review-image posiciona
    // estrellas y titulo 1:1; el nombre lo vuelve inline el script global de la tienda (.review-text).
    slides.forEach(function(slide){
      if(!slide.classList.contains('has-review-image') && slide.querySelector('.pdp-review__image')){
        slide.classList.add('has-review-image');
      }
    });
    function nearestIndex(){var best=0,bd=1e9;slides.forEach(function(s,i){var d=Math.abs(s.offsetLeft-slider.scrollLeft);if(d<bd){bd=d;best=i;}});return best;}
    function maxScroll(){return slider.scrollWidth-slider.clientWidth;}
    var anim=null;
    function animateTo(target){
      if(anim){cancelAnimationFrame(anim);anim=null;}
      target=Math.max(0,Math.min(target,maxScroll()));
      var start=slider.scrollLeft, dist=target-start, t0=null;
      if(Math.abs(dist)<1){slider.scrollLeft=target;return;}
      function frame(ts){if(t0===null)t0=ts;var p=Math.min((ts-t0)/SPEED,1);slider.scrollLeft=start+dist*easeOutCubic(p);if(p<1){anim=requestAnimationFrame(frame);}else{anim=null;}}
      anim=requestAnimationFrame(frame);
    }
    function goTo(i){i=Math.max(0,Math.min(i,slides.length-1));animateTo(slides[i].offsetLeft);}
    if(next) next.addEventListener('click',function(e){e.preventDefault();goTo(nearestIndex()+1);});
    if(prev) prev.addEventListener('click',function(e){e.preventDefault();goTo(nearestIndex()-1);});
    var down=false,sx=0,sl=0,startIdx=0,t0=0,dragged=false;
    slider.addEventListener('pointerdown',function(e){
      if(e.pointerType==='touch')return;if(e.pointerType==='mouse'&&e.button!==0)return;
      if(anim){cancelAnimationFrame(anim);anim=null;}
      down=true;dragged=false;sx=e.clientX;sl=slider.scrollLeft;startIdx=nearestIndex();t0=e.timeStamp;
      try{slider.setPointerCapture(e.pointerId);}catch(_){}
    });
    slider.addEventListener('pointermove',function(e){
      if(!down)return;var dx=e.clientX-sx;
      if(!dragged&&Math.abs(dx)>TAP_PX){dragged=true;slider.classList.add('is-dragging');}
      if(dragged){slider.scrollLeft=Math.max(0,Math.min(sl-dx,maxScroll()));}
    });
    function release(e){
      if(!down)return; down=false;
      try{slider.releasePointerCapture(e.pointerId);}catch(_){}
      if(!dragged){return;}
      slider.classList.remove('is-dragging');
      var dx=e.clientX-sx, dt=e.timeStamp-t0;
      var w=slides[Math.min(startIdx,slides.length-1)].getBoundingClientRect().width||1;
      var target=startIdx;
      if(Math.abs(dx)>w*LONG_RATIO||(dt<SHORT_MS&&Math.abs(dx)>SHORT_PX)){target=startIdx+(dx<0?1:-1);}
      goTo(target);
      var kill=function(ev){ev.stopPropagation();ev.preventDefault();slider.removeEventListener('click',kill,true);};
      slider.addEventListener('click',kill,true);
      setTimeout(function(){slider.removeEventListener('click',kill,true);},50);
    }
    slider.addEventListener('pointerup',release);
    slider.addEventListener('pointercancel',function(e){if(down){down=false;slider.classList.remove('is-dragging');}});
  }
  // position the native reviews section the way the store's Intelligems script used to
  // position the (now deleted) instant one: mobile -> just above the product name;
  // desktop -> right after .product-block--header (or before .instant-skeleton-wrapper
  // if that placeholder still exists). Re-applied on load/resize + a few timeouts to
  // survive the theme's late mobile reorder.
  // HB2 fix carga: la seccion nace display:none (style inline del liquid) y solo se
  // muestra cuando ya quedo en su posicion final (.hbpp2rev-positioned). En mobile
  // "final" = despues de que el reorden del theme creo .mobile-wrapper (o layout-ready);
  // si aun no, los retries de 200/600/1200ms la revelan. Fallback duro a los 3s.
  var MOBILE_BP=768;
  function markReady(natSec){ natSec.classList.add('hbpp2rev-positioned'); }
  function reposition(){
    var nat=document.querySelector('.hbpp2reviews'); if(!nat) return;
    var natSec=nat.closest('.shopify-section'); if(!natSec) return;
    if(window.innerWidth<=MOBILE_BP){
      var nameEl=document.querySelector('.product-name');
      if(nameEl){
        var mw=document.querySelector('.mobile-wrapper');
        var anchor=(mw&&mw.contains(nameEl))?nameEl:(nameEl.closest('.product-block')||nameEl);
        if(anchor && anchor.parentNode && natSec.nextSibling!==anchor){
          anchor.parentNode.insertBefore(natSec, anchor);
        }
        if(mw||document.body.classList.contains('layout-ready')) markReady(natSec);
      }
    } else {
      var skel=document.querySelector('.instant-skeleton-wrapper');
      if(skel && skel.parentNode){
        if(skel.previousElementSibling!==natSec){ skel.parentNode.insertBefore(natSec, skel); }
      } else {
        var ref=document.querySelector('.product-block--header');
        if(ref && ref.parentNode && ref.nextSibling!==natSec){
          ref.parentNode.insertBefore(natSec, ref.nextSibling);
        }
      }
      markReady(natSec);
    }
    var sk=document.querySelector('.instant-skeleton-wrapper'); if(sk) sk.style.display='none';
  }
  // the deleted instant reviews used to hide this placeholder after positioning
  // (placeReviews -> instantSkeleton.style.display='none'). Instant is gone, so hide it
  // here or it shows as an empty grey box on desktop.
  function hideSkeleton(){ var sk=document.querySelector('.instant-skeleton-wrapper'); if(sk) sk.style.display='none'; }
  function init(){[].slice.call(document.querySelectorAll('.hbpp2reviews')).forEach(setup); reposition(); hideSkeleton();}
  // el <script> va SIN defer al final del markup de la seccion: el DOM propio y las
  // anclas (main-product va antes en el template) ya existen -> posiciona durante el
  // parse, antes del primer paint. DOMContentLoaded queda de backstop (init es idempotente).
  init();
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  window.addEventListener('load', reposition);
  var rt; window.addEventListener('resize', function(){ clearTimeout(rt); rt=setTimeout(reposition,80); });
  [200,600,1200].forEach(function(ms){ setTimeout(reposition, ms); });
  // mobile: revelar al frame siguiente de que el reorden del theme cree .mobile-wrapper
  // (los timeouts fijos dejan un hueco de hasta 200ms visible; rAF no). Backstop: los
  // timeouts y DOMContentLoaded siguen activos por si rAF no corre (tab en background).
  (function pollWrapper(){
    if(document.querySelector('.mobile-wrapper')||document.body.classList.contains('layout-ready')){ reposition(); return; }
    if(document.readyState==='loading'||performance.now()<5000){ requestAnimationFrame(pollWrapper); }
  })();
  // fallback: nunca dejar la seccion oculta (p.ej. mobile sin reorden/layout-ready)
  setTimeout(function(){ var n=document.querySelector('.hbpp2reviews'); var s=n&&n.closest('.shopify-section'); if(s) markReady(s); }, 3000);
})();
